import {buildImageObj, cn, getBlogUrl} from "../../lib/helpers";
import styles from "./blog-post-preview.module.css";
import {imageUrlFor} from "../../lib/image-url";
import {responsiveTitle3} from "../typography.module.css";
import PortableText from "../portableText";
import {Link} from "gatsby";
import React from "react";

export default function SmallBlogPostPreview(props) {
  return <div
    className={styles.smallPreview}
  >
    <div className={cn(styles.leadMediaThumb, styles.smallPreviewImg)}>
      {props.mainMedia &&  props.mainMedia.image && props.mainMedia.image.asset && (
        <img
          src={imageUrlFor(buildImageObj(props.mainMedia.image))
            .url()}
          alt={props.mainMedia.image.alt}
        />
      )}
    </div>
    <div className={cn(styles.text, styles.smallPreviewText)}>
      <h3 className={cn(responsiveTitle3, styles.title)}>{props.title}</h3>
      {props._rawExcerpt && (
        <div className={styles.excerpt}>
          <PortableText blocks={props._rawExcerpt} />
        </div>
      )}
    </div>
    <Link
      className={styles.readMoreLinkSmallPreview}
      to={getBlogUrl(props.publishedAt, props.slug.current)}
    >
      Read More
    </Link>
  </div>
}
